class Validator {

    validateEmail(email) 
    {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    hasOnlySpecialCharater(val) 
    {
        if(val.trim().length > 0) {
            var re = /^[A-Za-z0-9ẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợàáêùúữÀÁÊÙÚỮđĐơƠịỊèéềếệềÈÉỀẾỆỀọỌờỜưừứựữửƯỪỨỰỬỮẦẤầấớỚòÒíÍỉỈĩĨóÓìÌỹỸỷỶýÝỵỴỳỲ]+(?: [A-Za-z0-9ẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợàáêùúữÀÁÊÙÚỮđĐơƠịỊèéềếệềÈÉỀẾỆỀọỌờỜưừứựữửƯỪỨỰỬỮẦẤầấớỚòÒíÍỉỈĩĨóÓìÌỹỸỷỶýÝỵỴỳỲ]+)*$/;
            var re_old = /[^A-Za-zẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợ\s*]/;
            if(re.test(val)) {
                return false
            } else {
                return true
            }
        }
    }

    hasNumberCharacter(val) 
    {
        if(val.trim().length > 0) {
            return /\d/.test(val);
        }
    }

    maxCharacter(val) 
    {
        var max = 50;
        var length = val.length;
        if(length <= max) {
            return true;
        } else {
            return max
        }
    }

    isIE() {
        var ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
        
        return is_ie; 
    }
    isME() {
        if(navigator.appVersion.indexOf('Edge') > -1) {
            return true;
        } else{
            return false;
        }

    }
    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };

    maxFileSize()
    {
        return '5000000';
    }
    
}

export default Validator
